/* unplugin-vue-components disabled */import script from "./Changephone.vue?vue&type=script&setup=true&lang=ts"
export * from "./Changephone.vue?vue&type=script&setup=true&lang=ts"

import "./Changephone.vue?vue&type=style&index=0&id=15de9d22&lang=less&scoped=true"

import exportComponent from "/Users/zhaoshunchen/Desktop/job/sinosig/workspace/shuke/sinosig-app-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15de9d22"]])

export default __exports__